"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOBILE_ACCESS_EVENTS = exports.TrackEventTypeEnum = void 0;
/**
 * Types of trackable events
 */
var TrackEventTypeEnum;
(function (TrackEventTypeEnum) {
    TrackEventTypeEnum["CLICK"] = "Click";
    TrackEventTypeEnum["BANNER_CLICK"] = "Banner Click";
    TrackEventTypeEnum["CONTENT_CLICKED"] = "Content Clicked";
    TrackEventTypeEnum["CONTENT_POST_CTA_CLICKED"] = "Content Post CTA Clicked";
    TrackEventTypeEnum["CONTENT_VIEWED"] = "Content Viewed";
    TrackEventTypeEnum["ORDER_AHEAD_MENU_OPENED"] = "Order Ahead Menu Opened";
    TrackEventTypeEnum["ORDER_AHEAD_ORDER_STARTED"] = "Order Ahead Order Started";
    TrackEventTypeEnum["CHECKOUT_INITIATED"] = "Order Ahead Checkout Initiated";
    TrackEventTypeEnum["SHARE_LINK_BUTTON_CLICKED"] = "Share Link Button Clicked";
    TrackEventTypeEnum["UTILITY_BUTTON_CLICKED"] = "Utility Button Clicked";
    TrackEventTypeEnum["LINK_IN_POST_CLICKED"] = "Link In Post Clicked";
    TrackEventTypeEnum["AMENITY_POST_CLICKED"] = "Amenity Post Clicked";
    TrackEventTypeEnum["OPENPATH_LOG"] = "Openpath instance";
    TrackEventTypeEnum["PROXY_LOG"] = "Proxy instance";
    TrackEventTypeEnum["HID_LOG"] = "HID instance";
    TrackEventTypeEnum["KASTLE_LOG"] = "Kastle instance";
    TrackEventTypeEnum["REFERRAL_LINK_CONSUMED"] = "Referral Link Consumed";
    TrackEventTypeEnum["USER_SURVEY_RESPONSE"] = "User Survey Response";
})(TrackEventTypeEnum = exports.TrackEventTypeEnum || (exports.TrackEventTypeEnum = {}));
exports.MOBILE_ACCESS_EVENTS = [
    TrackEventTypeEnum.OPENPATH_LOG,
    TrackEventTypeEnum.PROXY_LOG,
    TrackEventTypeEnum.HID_LOG,
    TrackEventTypeEnum.KASTLE_LOG,
];
//# sourceMappingURL=track.event-type.js.map